export { default } from './dist/vue-content-placeholders.common'
export * from './dist/vue-content-placeholders.common'
import './dist/vue-content-placeholders.css'



//////////////////
// WEBPACK FOOTER
// ./~/vue-content-placeholders/index.js
// module id = 205
// module chunks = 1